import React, { FC } from 'react';
import { TypeTextCtaFields } from '@/core/generated-types';
import classNames from 'classnames';
import styles from './TextCta.module.scss';

const TextCta: FC<TypeTextCtaFields> = ({ title, subtitle }) => {
  return (
    <div className={classNames('px-8 py-16', styles.root)}>
      <div className="mx-auto max-w-[740px] text-center">
        <div
          className="text-[32px] font-bold leading-[40px] md:text-[40px] md:leading-[56px]"
          data-testid="title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {subtitle && (
          <div className="mt-4 text-lg" data-testid="subtitle">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(TextCta);
